import React from 'react';
import { Stack, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { AssignmentRuleType, DimensionItem } from '../../../../../services/WorkflowService';

interface RuleTypeSelectorProps {
  value: AssignmentRuleType;
  ruleTypes: DimensionItem[] | undefined;
  isLoading: boolean;
  onChange: (type: AssignmentRuleType) => void;
}

export const RuleTypeSelector: React.FC<RuleTypeSelectorProps> = ({ value, ruleTypes, isLoading, onChange }) => (
  <>
    <FormControl size="small" sx={{ minWidth: 250 }}>
      <InputLabel>Assignment Rule</InputLabel>
      <Select
        value={value}
        label="Assignment Rule"
        onChange={(e) => onChange(e.target.value as AssignmentRuleType)}
        disabled={isLoading}
      >
        {ruleTypes?.map((rt) => (
          <MenuItem key={rt.value} value={rt.name}>{rt.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
    {ruleTypes && (
      <Stack direction="row" spacing={0.5} alignItems="center">
        <InfoOutlined sx={{ color: '#94a3b8', fontSize: 14 }} />
        <Typography variant="caption" sx={{ color: '#64748b' }}>
          {ruleTypes.find((rt) => rt.name === value)?.description || ''}
        </Typography>
      </Stack>
    )}
  </>
);
